export const generatePhysicalRiskTemplate = `
<!DOCTYPE html>
<html>
<head>
<style>
  table { border-collapse: collapse; width: 100%; page-break-inside: auto; table-layout: fixed; font-size: 10px; }
  th, td { border: 1px solid #ddd; padding: 4px; text-align: left; vertical-align: top; word-wrap: break-word; overflow-wrap: break-word; hyphens: auto; }
  th { background-color: #f2f2f2; font-weight: bold; font-size: 9px; line-height: 1.2; }
  td { font-size: 9px; line-height: 1.2; max-width: 0; }
  tr { page-break-inside: avoid; }
  .property-id { width: 60px; }
  .flood-risk { width: 100px; }
  .other-risk { width: 80px; }
  .mitigation-measures { width: 120px; max-width: 120px; white-space: normal; word-break: break-all; }
  .mitigation-plans { width: 100px; }
  .comments { width: 80px; }
</style>
</head>
<body>
    <div>
        <h2 class="pdf-table-heading">Sustainability</h2>
        <h3 class="pdf-table-sub-heading">Physical Risk Consideration</h3>
        <table id="print-pdf-table" class="sustainability-table">
            <tr>
                <th class="property-id">Property Id</th>
                <th class="flood-risk">Current Exposure to Flood Risk</th>
                <th class="other-risk">Current Exposure to Wildfire Risk</th>
                <th class="other-risk">Current Exposure to Heat Stress</th>
                <th class="other-risk">Current Exposure to Drought Stress</th>
                <th class="other-risk">Current Exposure to Tropical Cyclone</th>
                <th class="mitigation-measures">Mitigation measures reported in the SSBB</th>
                <th class="mitigation-plans">Describe mitigation plans included in this budget, if any</th>
                <th class="comments">Optional comments</th>
            </tr>
            {{#each properties}}
            <tr>
                <td class="property-id">{{propertyId}}</td>
                <td class="flood-risk"><strong>River (Fluvial) Flooding:</strong><br>{{physicalRisk.riverFloodDefendedRisk}}<br><br><strong>Sea Level Rise:</strong><br>{{physicalRisk.seaLevelRisk}}</td>
                <td class="other-risk">{{physicalRisk.wildfireRisk}}</td>
                <td class="other-risk">{{physicalRisk.heatStress}}</td>
                <td class="other-risk">{{physicalRisk.droughtStress}}</td>
                <td class="other-risk">{{physicalRisk.tropicalCyclone}}</td>
                <td class="mitigation-measures">{{{physicalRisk.mitigationMeasuresCount}}}</td>
                <td class="mitigation-plans">{{physicalRisk.mitigationPlans}}</td>
                <td class="comments">{{physicalRisk.comments}}</td>
            </tr>
            {{/each}}
        </table>
    </div>
</body>
</html>
`;

export const generateRegulatoryRiskTemplate = `
<!DOCTYPE html>
<html>
<head>
</head>
<body>
    <div>
        <h3 class="pdf-table-sub-heading">Regulatory Risk Consideration</h3>
        <table id="print-pdf-table" class="sustainability-table">
            <tr>
                <th>Property Id</th>
                <th>Current Exposure to Building Performance Standard</th>
                <th>Current Exposure to Additional Regulatory Requirement</th>
                <th>Compliance Status According to SSBB Record</th>
                <th>Compliance Status Comments or Corrections</th>
                <th>Does this budget include cost to procure a vendor for compliance plan?</th>
                <th>Does this budget include projects to come into compliance with the regulation?</th>
                <th>Optional Comments</th>
            </tr>
            {{#each properties}}
            <tr>
                <td>{{propertyId}}</td>
                <td>{{regulatoryRisk.buildingPerformanceStandard}}</td>
                <td>{{regulatoryRisk.additionalRequirements}}</td>
                <td>{{regulatoryRisk.complianceStatus}}</td>
                <td>{{regulatoryRisk.complianceComments}}</td>
                <td>{{regulatoryRisk.vendorProcurement}}</td>
                <td>{{regulatoryRisk.complianceProjects}}</td>
                <td>{{regulatoryRisk.comments}}</td>
            </tr>
            {{/each}}
        </table>
    </div>
</body>
</html>
`;

export const generateDecarbonizationTemplate = `
<!DOCTYPE html>
<html>
<head>
</head>
<body>
    <div>
        <h3 class="pdf-table-sub-heading">Decarbonization Assessment</h3>
        <table id="print-pdf-table" class="sustainability-table">
            <tr>
                <th>Property Id</th>
                <th>Decarbonization assessment status according to SSBB record</th>
                <th>Does this budget include the cost to complete a net zero audit?</th>
                <th>Optional comments</th>
            </tr>
            {{#each properties}}
            <tr>
                <td>{{propertyId}}</td>
                <td>{{decarbonization.assessmentStatus}}</td>
                <td>{{decarbonization.statusComments}}</td>
                <td>{{decarbonization.comments}}</td>
            </tr>
            {{/each}}
        </table>
    </div>
</body>
</html>
`;

export const generateSSBBTemplate =  `
<!DOCTYPE html>
<html>
<head>
</head>
<body>
    <div>
        <h3 class="pdf-table-sub-heading">SSBB Minimum Standards</h3>
        <table id="print-pdf-table" class="sustainability-table">
            <tr>
                <th>Property Id</th>
                <th>Are any SSBB features included in this budget?</th>
                <th>List the SSBB features included in this budget</th>
                <th>Optional comments</th>
            </tr>
            {{#each properties}}
            <tr>
                <td>{{propertyId}}</td>
                <td>{{ssbbStandards.featuresIncluded}}</td>
                <td>{{ssbbStandards.featuresList}}</td>
                <td>{{ssbbStandards.comments}}</td>
            </tr>
            {{/each}}
        </table>
    </div>
</body>
</html>
`;

